import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import Container from './style'

interface Props {
  titleTH: string
  titleEN?: string
  href?: string
  style?: CSSProperties
  className?: string
  id?: string
}

function EgDocument({
  id,
  titleTH,
  titleEN,
  href,
  className,
  style,
}: Props): ReactElement {
  return (
    <Container
      id={id}
      href={href}
      className={className}
      target="_blank"
      rel="noreferrer"
      style={style}
    >
      <section className="left-container">
        <h4>{titleTH}</h4>
        {titleEN && <p>{titleEN}</p>}
      </section>
      {href && (
        <section className="right-container">
          <h4>ดูตัวอย่าง</h4>
        </section>
      )}
    </Container>
  )
}

EgDocument.propTypes = {
  titleTH: PropTypes.string.isRequired,
  titleEN: PropTypes.string,
  href: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

EgDocument.defaultProps = {
  className: '',
}

export default memo(EgDocument)
